import React from 'react';
import Head from 'next/head';
import { string } from 'prop-types';

/**
 * factory function to return a ScriptTag component with desired props. because
 * all <script /> tags are not created equal. defaults to:
 *
 *   <script type="">
 *   </script>
 *
 * @export
 * @param {Object} [defaults={}] defaults for script tag
 * @param {String} [defaults.keyName='type'] the HTML attr to use for the 'name' key
 * @param {String} [defaults.valueName='content'] the HTML attr to use for the 'content' key
 * @returns {Function} factory function
 */
export default function createScriptTag(defaults = {}) {
  const { keyName = 'type' } = defaults;

  /**
   * ScriptTag is a component that renders an "abstract" <script /> tag (no
   * defined keyName and valueName)
   */
  function ScriptTag(props) {
    const { name, value } = props;

    const scriptProps = {
      [keyName]: name,
      dangerouslySetInnerHTML: { __html: value }
    };

    return (
      <Head>
        <script {...scriptProps} />
      </Head>
    );
  }

  ScriptTag.propTypes = {
    // name and value props are from the 'data' attr in our bundle item schema
    name: string.isRequired,
    value: string
  };

  ScriptTag.defaultProps = { value: '' };

  return ScriptTag;
}
